var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainContentTabs',{attrs:{"tabs":[
        {tab : 'precios-abonos', nombre: 'Configurar precios de los abonos'},
        {tab : 'vouchers', nombre: 'Configurar cupones de descuento'},
        ...(_vm.teatro.invitaciones_para_abonados === 1 ? [{tab : 'invitaciones', nombre: 'Configurar invitaciones abonados'}] : [])
    ],"initialTab":"precios-abonos"}},[_c('template',{slot:"precios-abonos"},[(_vm.lista.place)?_c('TabPrices'):_c('TabPricesSinRecinto')],1),_c('template',{slot:"vouchers"},[_c('TabVouchers')],1),_c('template',{slot:"invitaciones"},[_c('TabInvitaciones')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }